import React, { useState } from 'react'
import { Breakpoint } from 'react-socks'
import { useSelector } from '~/store/hooks'

import Scrollbar from 'react-scrollbars-custom'

import trads from '~/intl/trads.json'

import NavLevel from '~/components/features/header/navLevel'

import { ArrowRight } from '~/icons/ArrowRight'

const MainNav = () => {
  const lang = useSelector((state) => state.lang)

  // state
  const [globalLevel, setLevel] = useState(1)
  const [globalActiveSubnav, setActiveSubnav] = useState(null)
  const [globalActiveSubSubnav, setActiveSubSubnav] = useState(null)
  const [globalActiveSubSubSubnav, setActiveSubSubSubnav] = useState(null)

  const changeLevel = (
    level,
    activeSubnav,
    activeSubSubnav,
    activeSubSubSubnav,
  ) => {
    setLevel(level)
    setActiveSubnav(activeSubnav)
    setActiveSubSubnav(activeSubSubnav)
    setActiveSubSubSubnav(activeSubSubSubnav)

    if (level > 1) {
      document
        .querySelector('.panel-nav--menu')
        .classList.add('has-subnav-open')
    }
  }

  const backNav = () => {
    let level = globalLevel - 1
    let activeSubnav = level < 2 ? null : globalActiveSubnav
    let activeSubSubnav = level < 3 ? null : globalActiveSubSubnav

    setLevel(level)
    setActiveSubnav(activeSubnav)
    setActiveSubSubnav(activeSubSubnav)
    setActiveSubSubSubnav(null)

    if (level < 2) {
      document
        .querySelector('.panel-nav--menu')
        .classList.remove('has-subnav-open')
    }
  }

  return (
    <nav className="flex main-nav-wrap">
      <button
        className={`panel-nav__back ${globalLevel > 1 ? 'is-visible' : ''}`}
        onClick={() => backNav()}
      >
        <ArrowRight className="icon-white" />
        <span className="text-label">{trads[lang]?.header?.back}</span>
      </button>

      <Breakpoint className="w-full" customQuery="(max-width: 1023px)">
        <NavLevel
          level={globalLevel}
          activeSubnav={globalActiveSubnav}
          activeSubSubnav={globalActiveSubSubnav}
          activeSubSubSubnav={globalActiveSubSubSubnav}
          lang={lang}
          changeLevel={changeLevel}
        />
      </Breakpoint>

      <Breakpoint className="w-full" customQuery="(min-width: 1024px)">
        <Scrollbar style={{ height: '100%' }}>
          <NavLevel
            level={globalLevel}
            activeSubnav={globalActiveSubnav}
            activeSubSubnav={globalActiveSubSubnav}
            activeSubSubSubnav={globalActiveSubSubSubnav}
            lang={lang}
            changeLevel={changeLevel}
          />
        </Scrollbar>
      </Breakpoint>
    </nav>
  )
}

export default MainNav
